import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Textarea,
  useDisclosure,
  Icon,
  useToast
} from '@chakra-ui/react';
import React from 'react';
import { FaEye } from 'react-icons/fa';
import { api } from '../../../../services/api';
import { user } from '../../../../helpers/user';
import { useSearchParams } from 'react-router-dom';

export function DrawerObs({ item }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const obsRef = React.useRef();
  const [loading, setLoading] = React.useState(false);

  const toast = useToast({
    position: 'top-right'
  });

  async function addObservacao() {
    if (obsRef.current.value === '') return;

    const params = {
      numero_nota: item.numero_nota,
      observacao: obsRef.current.value
    };

    try {
      setLoading(true);

      const response = await api.post('/site/v2/crm-controle/atualiza-observacao-entrega', params);

      if (response.status === 200) {
        onClose();
        toast({
          title: 'Observação salva com sucesso!',
          status: 'success',
          duration: 3000,
          isClosable: true
        });
      }

      obsRef.current.value = '';
      setLoading(false);
    } catch (err) {
      console.error(err);
      toast({
        title: 'Erro ao salvar observação!',
        status: 'error',
        duration: 3000,
        isClosable: true
      });
      setLoading(false);
    }
  }

  const [searchParams] = useSearchParams();

  const codVend = searchParams.get('codVend');

  if (user?.codigo_vendedor !== '0' && user?.codigo_vendedor !== codVend) return null;

  return (
    <>
      <Icon
        as={FaEye}
        ref={btnRef}
        colorScheme="teal"
        onClick={onOpen}
        fontSize="20px"
        cursor="pointer"
        _hover={{ color: 'blue.500' }}>
        Obs
      </Icon>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Observação</DrawerHeader>

          <DrawerBody>
            <Textarea placeholder="Digite sua observação aqui..." minH="full" ref={obsRef} />
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => {
                addObservacao();
              }}
              isLoading={loading}>
              Salvar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
